const UUID =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

/** Cross-session tabs share a recovery hint, never a recipient's record view. */
export function recordInvalidationBroadcast(
  eventType: string,
  entityType: string,
  organizationId: string,
  tabId: string,
  sourceEventId?: string,
  readerDenied = false,
) {
  // Legacy event identities sometimes contain record IDs. Preserve only the
  // opaque UUID publication identity; otherwise generate a new opaque hint.
  const eventId =
    sourceEventId && UUID.test(sourceEventId)
      ? sourceEventId
      : crypto.randomUUID()
  return {
    type: eventType,
    entityType,
    entityId: eventId,
    data: {
      organizationId,
      _invalidate: true,
      _bulk: true,
      _eventId: eventId,
      ...(readerDenied ? { _readerDenied: true } : {}),
    },
    timestamp: Date.now(),
    messageId: crypto.randomUUID(),
    source: 'socket' as const,
    tabId,
  }
}
